export const providers = [
  {
    id: 'IDDATAWEB',
    name: 'ID Dataweb',
    icon: 'IDDataweb',
    description:
      'Prompt users to answer knowledge-based authentication (KBA) questions.',
  },
  // Commenting 1Kosmos for 25.A release
  // {
  //   id: '1KOSMOS',
  //   name: '1Kosmos',
  //   icon: 'Kosmos',
  //   description:
  //     'Prompt users to answer knowledge-based authentication (KBA) questions.',
  // },
];

export const PROVIDER_NAMES = {
  IDDATAWEB: 'IDDATAWEB',
  '1KOSMOS': '1KOSMOS',
};

export const CONFIG_ATTRIBUTES = {
  USERNAME: 'USERNAME',
  PASSWORD: 'PASSWORD',
  APIKEY: 'APIKEY',
  REDIRECT_URL: 'REDIRECT_URL',
};

export interface Provider {
  id: string;
  name: string;
  icon: string;
  description: string;
}
